import { render, staticRenderFns } from "./WorkClientOfficesModal.vue?vue&type=template&id=d770efea&"
import script from "./WorkClientOfficesModal.vue?vue&type=script&lang=js&"
export * from "./WorkClientOfficesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports